module.exports = __webpack_public_path__ + "static/pillow-2-4de56024788c14fe5d1cbc3384d3267a.webp";